import axios from 'axios'

function getSigv4Url() {
    var urlString = `${process.env.VUE_APP_APIURL}/iot/sigv4`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

export default {
    getSigv4Url
};